
import Sidebar from "./Sidebar";
import Header from "./Header";

function Layout({ children }) {
  return (
    <div className="d-flex">
      <Sidebar />
      <div className="flex-grow-1">
        <Header />
        <div className="p-4 bg-light" style={{ minHeight: "100vh" }}>
          {children}
        </div>
      </div>
    </div>
  );
}

export default Layout;
